import * as types from '../mutation-types'
import vueCookie from 'vue-cookie'
import core from '@/js/core/core'


// initial state
const state = {
  account: null,
  tvIconFlag: window.tvIconFlag,
  privateMessageCount: 0,
  chipSetting: {
    chipAmountOption: {
      min: 50,
      med: 150,
      big: 250,
      big2: 500,
      big3: 1000,
      max: 0,
    },
  },
  passcode: {
    noShowAgainModel: false,
    noShowAgainList: [],
    showReminder: true,
  },
  userdetail: {
    usrn: '-1',
  },
  timeZone: window._timeZone,
  editionStand:window._editionStand,
  previous_edition: window._editionStand==3?1:window._editionStand,
  sortHot : window._sortHot,
  skinTheme: window._skinTheme,
  betterOdds: window._betterOdds,
  filterLeague: window._filterLeague,
  _theme: window.theme,
  accSetting: window.accSetting,
  accTimeZone: window._accTimeZone,
  comp_token: window.comp_token,
  accBetSetting: window.accBetSetting,
  _sortHot: window.sortHot,
  _betterOdds: window.betterOdds,
  _editionStand: window.edition,
  _filterLeague: window.filterLeague,
  showOdds: window.showOdds == 0? false:true,
}

// getters
const getters = {
  account: state => state.account,
  timeZone: state => state.timeZone,
  editionStand:state =>state.editionStand,
  previous_edition:state => state.previous_edition,
  sortHot : state => state.sortHot,
  tvIconFlag: state => state.tvIconFlag,  
  privateMessageCount: state => state.privateMessageCount,  
  chipSetting: state => state.chipSetting,
  passcode: state => state.passcode,
  skinTheme : state => state.skinTheme,
  betterOdds : state => state.betterOdds,
  filterLeague : state => state.filterLeague,
  _theme: state => state._theme,
  accSetting: state => state.accSetting,
  accTimeZone: state => state.accTimeZone,
  comp_token: state => state.comp_token,
  _sortHot: state => state._sortHot,
  _betterOdds: state => state._betterOdds,
  _editionStand: state => state._editionStand,
  _filterLeague: sttae => state._filterLeague,
  showOdds: sttae => state.showOdds,
  accBetSetting: state => state.accBetSetting,
  chipAmountOption: (state, getters) => {
    if(getters.account.previewFlag == true){
      return state.chipSetting.chipAmountOption
    } 
    // if(!vueCookie.get(window.compcode + '_acc_' + getters.account.acccode)) {
    if(state.accBetSetting == null || Object.keys(state.accBetSetting).length == 0){
      // vueCookie.set(window.compcode + '_acc_' + getters.account.acccode, JSON.stringify(state.chipSetting.chipAmountOption))
      $.ajax({
        method: 'post',
        url: _baseUrl + '/callCookies',
        data: {
          com_code: window.compcode,
          acc: JSON.stringify(state.chipSetting.chipAmountOption),
          acc_code: getters.account.acccode,
          enableLoading:false
        },
      }).done((res) => {
        
      })
      return state.chipSetting.chipAmountOption
    } else {
      // return JSON.parse(vueCookie.get(window.compcode + '_acc_' + getters.account.acccode))
      return state.accBetSetting
    }
  },
  userdetail: (state, getters) => {
    if(!vueCookie.get('UID')) {
      vueCookie.set('UID', JSON.stringify(state.userdetail))
      return state.userdetail
    } else {
      return JSON.parse(vueCookie.get('UID'))
    }
  },
  noShowAgainList: (state, getters) => {
    if(vueCookie.get(window.compcode + '_xrmd')) {
      state.passcode.noShowAgainList = JSON.parse(vueCookie.get(window.compcode + '_xrmd'))
      return state.passcode.noShowAgainList
    }
    return state.passcode.noShowAgainList
  }
}

// actions
const actions = {
  getAnn(context, payload) {
    var params = payload.params
    var token_val = params.token
    if(params.token=='' || params.token==undefined){
      var token_val = token.arr_7
    }
    params.token = token_val
    this.commit('FULL_LOAD', true)
    core.$ajax({
      url: window._baseUrl + '/annhistory/getAnn',
      type: 'get',
      data: params,
    }).done(response => {
      if(params.selAnn == '3' || params.selAnn == '2') {
        state.privateMessageCount = response.c
      }
      this.commit('FULL_LOAD', false)
      if(payload.callback) {
        return payload.callback(response)
      }
    })
  },
  logoutAccount(context, payload){
    core.$ajax({
      method: 'post',
      url: _baseUrl + '/login',
      data: {
        action: 'logout',
        enableLoading: false,
        token: token.arr_10,
      },
    }).done(((res)=> {
      console.log(res)
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  }
}

// mutations
const mutations = {

  [types.ACCOUNT] (state, payload ) {
    payload.selectedMarket = null
    state.account = payload
    // if(vueCookie.get(window.compcode + '_acc')){
    if(this.getters.accSetting && Object.keys(this.getters.accSetting).length > 0){
      // var accCookie = JSON.parse(vueCookie.get(window.compcode + '_acc'))
      var accCookie = this.getters.accSetting
      state.account.oddsType = accCookie.oddsType
      if(typeof(accCookie.showReminder) !== 'undefined') {
        state.account.showReminder = accCookie.showReminder
        state.passcode.showReminder = accCookie.showReminder
      }
    }
    // vueCookie.set(window.compcode + '_acc', JSON.stringify(state.account))
    // vueCookie.set(window.compcode + '_token', btoa(state.account.acccode))
    // if(!vueCookie.get(window.compcode + '_acc') || !vueCookie.get(window.compcode + '_token') || 
    //   // (state.account.currCL != '-' && state.account.currCL != JSON.parse(vueCookie.get(window.compcode + '_acc')).currCL) ||  
    //   state.account.oddsType != JSON.parse(vueCookie.get(window.compcode + '_acc')).oddsType || 
    //   btoa(account.acccode) != vueCookie.get(window.compcode + '_token')){
    if(!state.accSetting || !state.comp_token || state.account.oddsType != state.accSetting.oddsType ||
       btoa(account.acccode) != state.comp_token){
      $.ajax({
        method: 'post',
        url: _baseUrl + '/callCookies',
        async: false,
        data: {
          com_code: window.compcode,
          acc: JSON.stringify(state.account),
          tkn: btoa(state.account.acccode),
        },
      }).done((res) => {
        
      })
    }

    var userdetail = {
      usrn: '',
    }

    if(!vueCookie.get('UID')){
      // userdetail.usrn = this.getters.account.acccode
      userdetail.usrn = this.getters.account.usrn
      if(!window.pch) {
        userdetail.usrn = '-1'
      }
      state.userdetail = userdetail
      vueCookie.set('UID', JSON.stringify(state.userdetail))
    }

  },

  [types.SELECTED_ODD] (state, payload ) {
    // var accCookie = JSON.parse(vueCookie.get(window.compcode + '_acc'))
    var accCookie = state.accSetting
    accCookie.oddsType = payload
    state.account = accCookie
    // vueCookie.set(window.compcode + '_acc', JSON.stringify(state.account))
    $.ajax({
      method: 'post',
      url: _baseUrl + '/callCookies',
      async: false,
      data: {
        com_code: window.compcode,
        acc: JSON.stringify(state.account),
      },
    }).done((res) => {
      
    })
    if(this.getters.arr_selectedTemplate.templateId == 3){
      //sport table page reload odds
      this.dispatch('getSportOdds', { token: token.arr_4 })
    }else if(this.getters.arr_selectedTemplate.templateId == 6){
      //allbet table page reload odds
      // var event = {event:this.getters.arr_selectedEvent}
      var event = this.getters.arr_selectedEvent
      this.dispatch('getSportAllBet', { 
        event: event, 
        token: token.arr_4,
      })
    }
  },

  [types.ACC_CHIP_SETTING] (state, payload) {
    var chipAmountOption = {
      min: 0,
      med: 0,
      big: 0,
    }

    if(payload && payload.isBetting) {
      // if(!vueCookie.get(window.compcode + '_acc_' + this.getters.account.acccode)) {
      if(state.accBetSetting == null || Object.keys(state.accBetSetting).length == 0){
        // vueCookie.set(window.compcode + '_acc_' + this.getters.account.acccode, JSON.stringify(state.chipSetting.chipAmountOption))
        $.ajax({
          method: 'post',
          url: _baseUrl + '/callCookies',
          async: false,
          data: {
            com_code: window.compcode,
            acc: JSON.stringify(state.chipSetting.chipAmountOption),
            acc_code: this.getters.account.acccode
          },
        }).done((res) => {
          
        })
        chipAmountOption = state.chipSetting.chipAmountOption
      } else {
        // chipAmountOption = JSON.parse(vueCookie.get(window.compcode + '_acc_' + this.getters.account.acccode))
        chipAmountOption = state.accBetSetting
      }
      chipAmountOption.max = payload.minMax.max
      state.chipSetting.minMax = payload.minMax
    } else {
      chipAmountOption = {
        min: payload.min,
        med: payload.med,
        big: payload.big,
      }
    }

    state.chipSetting.chipAmountOption = chipAmountOption
    // vueCookie.set(window.compcode + '_acc_' + this.getters.account.acccode, JSON.stringify(state.chipSetting.chipAmountOption))
    $.ajax({
      method: 'post',
      url: _baseUrl + '/callCookies',
      data: {
        com_code: window.compcode,
        acc: JSON.stringify(state.chipSetting.chipAmountOption),
        acc_code: this.getters.account.acccode
      },
    }).done((res) => {
      
    })
  },

  SET_ACC_CHIP_SETTING (state, payload) {
    // if(!vueCookie.get(window.compcode + '_acc_' + state.account.acccode)) {
    if(state.accBetSetting == null || Object.keys(state.accBetSetting).length == 0){
        // vueCookie.set(window.compcode + '_acc_' + state.account.acccode, JSON.stringify(state.chipSetting.chipAmountOption))
        $.ajax({
          method: 'post',
          url: _baseUrl + '/callCookies',
          async: false,
          data: {
            com_code: window.compcode,
            acc: JSON.stringify(state.chipSetting.chipAmountOption),
            acc_code: state.account.acccode,
            callback: 1,
          },
        }).done((res) => {
          state.accBetSetting = JSON.parse(res)
        })
    }
  },

  [types.PASSCODE] (state, payload) {
    state.passcode = payload
  },

  SHOW_PASSCODE_REMINDER (state, payload) {
    state.passcode.showReminder = payload
    // if(vueCookie.get(window.compcode + '_acc')){
    if(state.accSetting){
      state.account.showReminder = payload
      // vueCookie.set(window.compcode + '_acc', JSON.stringify(state.account))
      $.ajax({
        method: 'post',
        url: _baseUrl + '/callCookies',
        async: false,
        data: {
          com_code: window.compcode,
          acc: JSON.stringify(state.account),
        },
      }).done((res) => {
        
      })
    }
  },

  CLOSE_REMINDER (state, payload) {
    state.passcode.noShowAgainModel = payload.noShow
    if(vueCookie.get(window.compcode + '_xrmd')){
      state.passcode.noShowAgainList = JSON.parse(vueCookie.get(window.compcode + '_xrmd'))
    }
    var accIndex = state.passcode.noShowAgainList.indexOf(payload.accCode);
    if (accIndex !== -1)  {
      if(payload.noShow) {
        state.passcode.noShowAgainList.push(payload.accCode)
      } else {
        state.passcode.noShowAgainList.splice(accIndex, 1)
      }
    } else {
      if(payload.noShow) {
        state.passcode.noShowAgainList.push(payload.accCode)
      }
    }
    vueCookie.set(window.compcode + '_xrmd', JSON.stringify(state.passcode.noShowAgainList) )
  },

  NO_SHOW_AGAIN_LIST (state, payload) {
    state.passcode.noShowAgainList = payload
  },

  SET_UID (state, payload) {
    var userdetail = {
      usrn: '',
    }

    userdetail.usrn = this.getters.account.usrn
    if(window.pch && window.pch != '') {
      userdetail.nsid = window.pch
    }
    state.userdetail = userdetail
    vueCookie.set('UID', JSON.stringify(state.userdetail))
  },

  REMOVE_UID (state, payload) {
    if(vueCookie.get('UID') && JSON.parse(vueCookie.get('UID')).usrn !== this.getters.account.usrn){
      var userdetail = {
        usrn: '-1',
      }
      vueCookie.set('UID', JSON.stringify(userdetail))
    }
    // vueCookie.delete('UID')
  },
  TIME_ZONE (state, payload) {
    state.timeZone.default = payload
    // if(!vueCookie.get(state.account.acccode+'_timeZone') || vueCookie.get(state.account.acccode+'_timeZone') && vueCookie.get(state.account.acccode+'_timeZone') != JSON.stringify(stkset)){
    if(!state.accTimeZone || state.accTimeZone && state.accTimeZone != stringify(stkset)){
      var stkset = {
        default: payload,
        timeS: state.timeZone.list[payload][0],
        timeA: state.timeZone.list[payload][1],
        format:state.timeZone.format,
      }
      $.ajax({
        method: 'post',
        url: _baseUrl + '/callCookies',
        async: false,
        data: {
          action: 'timeZone',
          timeZoneSet: JSON.stringify(stkset),
          acc_code: state.account.acccode
        },
      }).done((res) => {
        
      })
      state.accTimeZone = stringify(stkset)
    }
  },

  SORT_HOT(state, payload) {
    state.sortHot = payload;
    // if(!vueCookie.get(state.account.acccode+'_sortHot') || vueCookie.get(state.account.acccode+'_sortHot') && vueCookie.get(state.account.acccode+'_sortHot') != state.sortHot ){
    if(!state._sortHot || state._sortHot && state._sortHot != state.sortHot){
        $.ajax({
          method: "post",
          url: _baseUrl + "/callCookies",
          async: false,
          data: {
            action: "sortHot",
            sortHotSet: state.sortHot,
            acc_code: state.account.acccode,
          },
        }).done((res) => {});
    }
    if(state.sortHot != this.getters.selectedSort){
      this.commit('SELECTED_SORT', payload)
    }
  },

  SKIN_THEME(state, payload) {
    state._theme = payload;
    // // if(!vueCookie.get(state.account.acccode+'_skinTheme') || vueCookie.get(state.account.acccode+'_skinTheme') && vueCookie.get(state.account.acccode+'_skinTheme') != state.skinTheme){
    // if(!state._theme || state._theme && state._theme != state.skinTheme){
    //   $.ajax({
    //     method: "post",
    //     url: _baseUrl + "/callCookies",
    //     async: false,
    //     data: {
    //       action: "skinTheme",
    //       skinThemeSet: state.skinTheme,
    //       acc_code: "Guest",
    //     },
    //   }).done((res) => {});
    //   state._theme = state.skinTheme
    // }
  },

  EDITIONSTAND(state, payload) {
    state.editionStand = payload;
    // if(!vueCookie.get(state.account.acccode+'_editionStand') || vueCookie.get(state.account.acccode+'_editionStand') && vueCookie.get(state.account.acccode+'_editionStand') != state.editionStand){
    if(!state._editionStand || state._editionStand && state._editionStand != state.editionStand){
      $.ajax({
        method: "post",
        url: _baseUrl + "/callCookies",
        async: false,
        data: {
          action: "edition",
          editionStandSet: state.editionStand,
          acc_code: state.account.acccode,
        },
      }).done((res) => {});
      state._editionStand = state.editionStand
    }
  },

  BETTER_ODDS(state, payload) {
    state.betterOdds = payload;
    // if(!vueCookie.get(state.account.acccode+'_betterOdds') || vueCookie.get(state.account.acccode+'_betterOdds') && vueCookie.get(state.account.acccode+'_betterOdds') != state.betterOdds){
    if(!state._betterOdds || state._betterOdds && state._betterOdds != state.betterOdds){
      $.ajax({
        method: "post",
        url: _baseUrl + "/callCookies",
        async: false,
        data: {
          action: "betterOdds",
          betterOddsSet: state.betterOdds,
          acc_code: state.account.acccode,
        },
      }).done((res) => {});
      state._betterOdds = state.betterOdds
    }
  },

  FILTER_LEAGUE(state, payload) {
    state.filterLeague = payload;
    // if(!vueCookie.get(state.account.acccode+'_filterLeague') || vueCookie.get(state.account.acccode+'_filterLeague') && vueCookie.get(state.account.acccode+'_filterLeague') != state.filterLeague){
    if(!state._filterLeague || state._filterLeague && state._filterLeague != state.filterLeague){
      $.ajax({
        method: "post",
        url: _baseUrl + "/callCookies",
        async: false,
        data: {
          action: "filterLeague",
          filterLeagueSet: JSON.stringify(state.filterLeague),
          acc_code: state.account.acccode,
        },
      }).done((res) => {});
      state._filterLeague = state.filterLeague
    }
  },

  PREVIOUS_EDITION(state, payload) {
    state.previous_edition = payload;
  },
  SHOW_ODDS_TOGGLE(state, payload) {
    state.showOdds = payload;
  },
  [types.ACCOUNT_FAV] (state, payload ) {
    if(!vueCookie.get(state.account.acccode+'_accfavlg_event') || vueCookie.get(state.account.acccode+'_accfavlg_event') && vueCookie.get(state.account.acccode+'_accfavlg_event') != JSON.stringify(payload.favdt)){
      $.ajax({
        method: 'post',
        url: _baseUrl + '/callCookies',
        async: false,
        data: {
          action: (payload.isFavLeague=='1') ? 'favLeagueEvent' : 'favEvent',
          fav: JSON.stringify(payload.favdt),
          acc_code: this.getters.account.acccode
        },
      }).done((res) => {
        
      })
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/score/vue/store/modules/account.js